import script from "./FormLanguages.vue?vue&type=script&lang=js"
export * from "./FormLanguages.vue?vue&type=script&lang=js"

import "./FormLanguages.vue?vue&type=style&index=0&id=48095a0e&lang=scss"

const __exports__ = script;

export default __exports__